import React from "react";
import styles from "../PanelUser/PanelLayout.module.css";
import { Link } from "react-router-dom";
import axiosInstance from "../../api/axiosConfig";

export default function ResumenEmpresa() {
  const [empresa, setEmpresa] = React.useState(null);

  React.useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) return;
    axiosInstance
      .get("/api/datapersonal", { headers: { Authorization: token } })
      .then((r) => setEmpresa(r.data))
      .catch(console.error);
  }, []);

  const stats = [
    { label: "Razón Social", sub: empresa?.reason_social || "—", value: empresa?.name || "—" },
    { label: "Estado", sub: "cuenta", value: empresa?.status || "—" },
  ];

  const quickActions = [
    { label: "Ver mis sedes", sub: "Gestión de sedes", to: "/panel/empresa/sedes" },
    { label: "Ver profesionales", sub: "Gestión de profesionales", to: "/panel/empresa/profesionales" },
    { label: "Mi perfil", sub: "Datos de la empresa", to: "/panel/empresa/perfil" },
  ];

  return (
    <>
      <div className={styles.statsGrid} style={{ gridTemplateColumns: "repeat(2, 1fr)" }}>
        {stats.map((s) => (
          <div key={s.label} className={styles.statCard}>
            <p className={styles.statValue}>{s.value}</p>
            <p className={styles.statTitle}>{s.label}</p>
            <p className={styles.statSub}>{s.sub}</p>
          </div>
        ))}
      </div>

      <div className={styles.card}>
        <div className={styles.cardHeader}>
          <h2 className={styles.cardTitle}>Acciones rápidas</h2>
        </div>
        <div className={styles.quickActions}>
          {quickActions.map((a) => (
            <Link key={a.to} to={a.to} className={styles.quickAction}>
              <span className={styles.quickActionTitle}>{a.label}</span>
              <span className={styles.quickActionSub}>{a.sub}</span>
            </Link>
          ))}
        </div>
      </div>
    </>
  );
}
